import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';

type DropdownContent = {
    id: number;
    text: string;
    icon: string;
    dataId: string;
};

export const getActionsDropdownContent = (
    onEdit?: () => void,
    onDuplicate?: () => void,
    onLink?: () => void,
    onShare?: () => void,
    onPin?: () => void,
    onUnpin?: () => void,
    onDelete?: () => void
): DropdownContent[] => {
    const content = [];

    if (onEdit) {
        content.push(buildEdit());
    }

    if (onDuplicate) {
        content.push(buildDuplicate());
    }

    if (onLink) {
        content.push(buildLink());
    }

    if (onShare) {
        content.push(buildShare());
    }

    if (onPin) {
        content.push(buildPin());
    }

    if (onUnpin) {
        content.push(buildUnpin());
    }

    if (onDelete) {
        content.push(buildDelete());
    }

    return content;
};

const buildEdit = () => ({
    id: 0,
    text: i18n.t('common.edit'),
    icon: 'edit',
    dataId: gtmIds.dashboard.actions.edit,
});

const buildDuplicate = () => ({
    id: 1,
    text: i18n.t('common.duplicate'),
    icon: 'duplicate',
    dataId: gtmIds.dashboard.actions.duplicate,
});

const buildLink = () => ({
    id: 2,
    text: i18n.t('common.link'),
    icon: 'link',
    dataId: gtmIds.dashboard.actions.link,
});

const buildShare = () => ({
    id: 3,
    text: i18n.t('common.share'),
    icon: 'share',
    dataId: gtmIds.dashboard.actions.share,
});

const buildPin = () => ({
    id: 4,
    text: i18n.t('dashboards.pinned.action.pin'),
    icon: 'push_pin',
    dataId: gtmIds.dashboard.actions.pin,
});

const buildUnpin = () => ({
    id: 5,
    text: i18n.t('dashboards.pinned.action.unpin'),
    icon: 'push_pin_off',
    dataId: gtmIds.dashboard.actions.unpin,
});

const buildDelete = () => ({
    id: 6,
    text: i18n.t('common.delete'),
    icon: 'delete',
    dataId: gtmIds.dashboard.actions.delete,
});
